import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { DatePicker } from "@/components/app/DatePicker";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TIME_CATEGORIES } from "@/lib/labels";

/** Formulaire de saisie d'une entrée de temps. */
export function TimeEntryForm({ form, setForm, missions, missionMap, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="border border-zinc-200 bg-white rounded-md p-6 space-y-3">
      <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500">Nouvelle saisie</div>
      <div><Label>Date</Label><DatePicker value={form.date} onChange={(v) => setForm({ ...form, date: v })} testid="time-date" /></div>
      <div>
        <Label>Catégorie</Label>
        <Select value={form.category} onValueChange={(v) => setForm({ ...form, category: v })}>
          <SelectTrigger data-testid="time-category"><SelectValue /></SelectTrigger>
          <SelectContent>{TIME_CATEGORIES.map((c) => (<SelectItem key={c.value} value={c.value}>{c.label}</SelectItem>))}</SelectContent>
        </Select>
      </div>
      <div><Label>Heures</Label><Input type="number" step="0.25" min="0" required value={form.hours} onChange={(e) => setForm({ ...form, hours: e.target.value })} data-testid="time-hours" /></div>
      <div>
        <Label>Mission (facultatif)</Label>
        <Select
          value={form.mission_id || "none"}
          onValueChange={(v) => setForm({ ...form, mission_id: v === "none" ? "" : v, client_id: v === "none" ? form.client_id : (missionMap[v]?.client_id || "") })}
        >
          <SelectTrigger data-testid="time-mission"><SelectValue placeholder="Aucune" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="none">Aucune</SelectItem>
            {missions.map((m) => (<SelectItem key={m.id} value={m.id}>{m.title}</SelectItem>))}
          </SelectContent>
        </Select>
      </div>
      <div><Label>Description</Label><Textarea rows={2} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></div>
      <Button type="submit" className="w-full bg-[#2E3192] hover:bg-[#1E2066]" data-testid="time-submit">Enregistrer</Button>
    </form>
  );
}
